import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import SearchIcon from '../icons/search'
import SuggestionsList from './suggestionsList'

const AutoSuggest = props => {
  const {
    isOpen,
    inputValue,
    currentSite,
    suggestions,
    inputName,
    placeholder,
    type,
    ariaLabel,
    styles,
    setWrapperRef,
    setTextInputRef,
    handleInputChange,
    handleInputFocus,
    handleKeyDown,
    handleKeyUp,
    focusedIndex,
    textInputRef,
    wrapperRef,
    setMenuRef,
    onMenuClick,
    handleMenuMouseEnter,
    handleMenuMouseLeave
  } = props

  const inputStyle = {
    borderRadius: isOpen && suggestions.length ? '7px 0 0 0' : '7px 0 0 7px'
  }

  const buttonStyle = {
    borderRadius: isOpen && suggestions.length ? '0 7px 0 0' : '0 7px 7px 0'
  }

  return (
    <div
      ref={setWrapperRef}
      className={styles.mainWrapper}
      data-test-selector="autosuggest"
    >
      <input
        ref={setTextInputRef}
        className={styles.input}
        style={inputStyle}
        placeholder={placeholder || ''}
        autoComplete="off"
        type={type || 'search'}
        aria-label={ariaLabel || 'search'}
        name={inputName || ''}
        value={inputValue}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
      />
      <button
        className={classNames(styles.button, styles[`-theme-${currentSite}`])}
        style={buttonStyle}
        defaultValue="Submit"
      >
        <SearchIcon />
      </button>
      {isOpen &&
        inputValue &&
        suggestions &&
        suggestions.length > 0 && (
          <SuggestionsList
            suggestions={suggestions}
            styles={styles}
            focusedIndex={focusedIndex}
            inputValue={inputValue}
            textInputRef={textInputRef}
            wrapperRef={wrapperRef}
            setMenuRef={setMenuRef}
            onMenuClick={onMenuClick}
            handleMenuMouseEnter={handleMenuMouseEnter}
            handleMenuMouseLeave={handleMenuMouseLeave}
          />
        )}
    </div>
  )
}

AutoSuggest.propTypes = {
  suggestions: PropTypes.array.isRequired,
  onInputChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  onSelectOption: PropTypes.func.isRequired,
  inputName: PropTypes.string,
  inputValue: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
  currentSite: PropTypes.string
}

export default AutoSuggest



// WEBPACK FOOTER //
// ./client/components/autosuggest/autosuggest.js